import React, { memo, useState } from "react";

const esImagenValida = (url) => {
  return (
    typeof url === "string" &&
    url.trim() !== "" &&
    !url.includes("via.placeholder.com")
  );
};

function PlaceholderEspecialMitico() {
  return (
    <div
      style={{
        width: "100%",
        height: "110px",
        background: "linear-gradient(135deg, #fff7ec 0%, #f0ddc5 100%)",
        borderBottom: "1px solid #f0dfc9",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        padding: "10px",
        boxSizing: "border-box",
        textAlign: "center",
      }}
    >
      <img
        src="/logo-mitico.png"
        alt="Mítico Amorcito"
        style={{
          maxWidth: "82px",
          maxHeight: "48px",
          objectFit: "contain",
          marginBottom: "6px",
        }}
      />

      <span
        style={{
          fontSize: "10px",
          fontWeight: "900",
          color: "#9a5c1f",
          letterSpacing: "0.3px",
        }}
      >
        Especial de Mítico
      </span>
    </div>
  );
}

function EspecialCard({ esp, onClick }) {
  const [mediaError, setMediaError] = useState(false);

  const tieneMediaValida = esImagenValida(esp?.url) && !mediaError;

  return (
    <div
      onClick={onClick}
      style={{
        backgroundColor: "#fff",
        width: "210px",
        borderRadius: "16px",
        overflow: "hidden",
        flexShrink: 0,
        border: "1px solid #eef",
        boxSizing: "border-box",
        boxShadow: "0 8px 20px rgba(0,0,0,0.06)",
        cursor: "pointer",
      }}
    >
      {tieneMediaValida ? (
        esp.tipo === "video" ? (
          <video
            src={esp.url}
            muted
            autoPlay
            loop
            playsInline
            onError={() => setMediaError(true)}
            style={{
              width: "100%",
              height: "110px",
              objectFit: "cover",
              display: "block",
            }}
          />
        ) : (
          <img
            src={esp.url}
            alt={esp.titulo || "Especial de Mítico"}
            loading="lazy"
            decoding="async"
            onError={() => setMediaError(true)}
            style={{
              width: "100%",
              height: "110px",
              objectFit: "cover",
              display: "block",
            }}
          />
        )
      ) : (
        <PlaceholderEspecialMitico />
      )}

      <div
        style={{
          padding: "10px",
          display: "flex",
          flexDirection: "column",
          gap: "4px",
        }}
      >
        <h4
          style={{
            margin: 0,
            fontSize: "13px",
            fontWeight: "800",
            color: "#111",
            lineHeight: "1.25",
            wordBreak: "break-word",
          }}
        >
          {esp.titulo}
        </h4>

        <p
          style={{
            margin: 0,
            fontSize: "11px",
            color: "#666",
            lineHeight: "1.35",
            wordBreak: "break-word",
          }}
        >
          {esp.descripcion}
        </p>

        {esp?.mostrarBoton !== false && (
          <div
            style={{
              marginTop: "6px",
              fontSize: "10px",
              fontWeight: "900",
              color: "#FF9900",
            }}
          >
            {esp?.textoBoton || "TOCA PARA PEDIR →"}
          </div>
        )}
      </div>
    </div>
  );
}

export default memo(EspecialCard);
